import thunk from 'redux-thunk'
import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'
import languageReducer from './language'
import deviceInfoReducer from '../features/upload-file/redux/deviceInfoSlice'
import grandParentBreadcrumbReducer from '../features/dashboard/redux/grandParentBreadcrumbSlice'
import operationPermissionsReducer from '../features/dashboard/redux/operationPermissionSlice'
import hamburgerStateReducer from '../features/dashboard/redux/hamburgerSlice'
import kpiListSlice from '../features/custom-performance-indicators/redux/kpiListSlice'
import deviceKpiListSlice from '../features/custom-performance-indicators/redux/deviceKpiListSlice'
import customKpiSlice from '../features/custom-performance-indicators/redux/customKpiSlice'
import assetListSlice from '../features/custom-performance-indicators/redux/assetListSlice'
import deviceParameterSlice from '../features/custom-performance-indicators/redux/deviceParameterSlice'
import createCustomKpiSlice from '../features/custom-performance-indicators/redux/createCustomKpiSlice'
import customKpiDetails from '../features/custom-performance-indicators/redux/customKpiDetailsSlice'
import deviceManagementDeviceListSlice from '../features/device-management/redux/deviceListSlice'
import deviceDeleteReducer from '../features/device-management/redux/deviceDeleteSlice'
import gatewayInfoSlice from '../features/device-management/redux/gatewayInfoSlice'
import assetCategoriesSlice from '../features/device-management/redux/assetCategoriesSlice'
import deviceTypeSlice from '../features/device-management/redux/deviceTypeSlice'
import deviceModelSlice from '../features/device-management/redux/deviceModelSlice'
import indicatorSlice from '../features/device-management/redux/indicatorSlice'
import deviceInfoSlice from '../features/device-management/redux/deviceInfoSlice'
import modbusParamsSlice from '../features/device-management/redux/modbusParamsSlice'
import updateDeviceReducer from '../features/device-management/redux/updateDeviceSlice'
import downloadImageReducer from '../features/device-management/redux/downloadImageSlice'
import imageUploadReducer from '../features/device-management/redux/imageUploadSlice'
import addDeviceIndicatorReducer from '../features/device-management/redux/addDeviceIndicatorSlice'
import addDeviceParameterReducer from '../features/device-management/redux/addDeviceParameterSlice'
import addDefaultParameterReducer from '../features/device-management/redux/addDefaultParameterSlice'
import gatewayManagementGatewayListSlice from '../features/gateway-management/redux/gatewayListSlice'
import assetManagementAssetListSlice from '../features/asset-managament/redux/assetListSlice'
import createAssetReducer from '../features/asset-managament/redux/createAssetSlice'
import imageUploadReducerAsset from '../features/asset-managament/redux/imageUploadSliceAsset'
import gatewayDeleteReducer from '../features/gateway-management/redux/gatewayDeleteSlice'
import assetInfoSlice from '../features/gateway-management/redux/assetInfoSlice'
import createDeviceReducer from '../features/device-management/redux/createDeviceSlice'
import siteInfoSlice from '../features/asset-managament/redux/siteInfoSlice'
import assetDeleteReducer from '../features/asset-managament/redux/assetDeleteSlice'
import modbusParamsSliceReducer from '../features/device-dashboard/redux/getModbusParamterslice'
import FlameSignaGraphDataSliceReducer from '../features/device-dashboard/redux/getFlameSignaGraphDataSlice'
import FlameSignaGraphDataSliceReducer_NEW from '../features/device-dashboard/redux/getFlameSignaGraphDataSliceNew'
import getFlameSignaGraphKPIDataSlice from '../features/device-dashboard/redux/getFlameSignaGraphKPIDataSlice'
import flowSignalParamDataSlice from '../features/device-dashboard/redux/getFlowSignaGraphParamDataSlice'
import flowSignalKpiDataSlice from '../features/device-dashboard/redux/getFlowSignaGraphKPIDataSlice'
import FlowSignaGraphDataSliceReducer from '../features/device-dashboard/redux/getFlowSignaGraphDataSlice'
import FlameSignaGraphDataAssetDashboardSliceReducer from '../features/asset-dashboard/redux/getFlameSignaGraphDataSlice'
import FlowSignaGraphDataAssetDashboardSliceReducer from '../features/asset-dashboard/redux/getFlowSignaGraphDataSlice'
import assetCategoriesSliceGateway from '../features/gateway-management/redux/assetCategoriesSliceGateway'
import gatewayTypeSlice from '../features/gateway-management/redux/gatewayTypeSlice'
import createGatewayReducer from '../features/gateway-management/redux/createGatewaySlice'
import imageUploadReducerGateway from '../features/gateway-management/redux/imageUploadSliceGateway'
import gatewayInfoSliceGateway from '../features/gateway-management/redux/gatewayInfoSliceGateway'
import updateGatewayReducer from '../features/gateway-management/redux/updateGatewaySlice'
import downloadImageReducerGateway from '../features/gateway-management/redux/downloadImageSliceGateway'
import siteList from '../features/custom-performance-indicators/redux/siteListSlice'
import DeviceListReducer from '../features/device-dashboard/redux/getDeviceListSlice'
import StandardandCustomListDataReducer from '../features/device-dashboard/redux/getStandardandCustomParamterSlice'
import updateAssetSlice from '../features/asset-managament/redux/updateAssetSlice'
import addDefaultIndicatorReducer from '../features/device-management/redux/addDefaultIndicatorSlice'
import siteManagementSiteListSlice from '../features/site-management/redux/siteListSlice'
import siteDeleteReducer from '../features/site-management/redux/siteDeleteSlice'
import createSiteReducer from '../features/site-management/redux/createSiteSlice'
import imageUploadReducerSite from '../features/site-management/redux/imageUploadSliceSite'
import editCustomKpiSlice from '../features/custom-performance-indicators/redux/editCustomKpiSlice'
import siteInfoReducer from '../features/site-management/redux/siteInfoSlice'
import downloadImageReducerSite from '../features/site-management/redux/downloadImageSliceSite'
import updateSiteReducer from '../features/site-management/redux/updateSiteSlice'
import kpiConfigurationSlice from '../features/custom-performance-indicators/redux/deviceKpiParameterSlice'
import DeviceStatusReducer from '../features/device-dashboard/redux/getDeviceStatusListSlice'
import AlertCountDetailsReducer from '../features/device-dashboard/redux/getAlertCountSlice'
import SaveDefaultViewDetailsReducer from '../features/device-dashboard/redux/saveDefaultViewSlice'
import AlertsNotificationReducer from '../features/device-dashboard/redux/getNotificationByFilterSlice'
import ClearNotificationReducer from '../features/device-dashboard/redux/clearNotificationServiceSlice'
import acknowledgeNotificationNotificationReducer from '../features/device-dashboard/redux/acknowledgeNotificationServiceSlice'
import DeviceOnlineStatusReducer from '../features/device-dashboard/redux/getDeviceStatusOnlineSlice'
import exportDeviceGrapData from '../features/device-dashboard/redux/exportGraphSlice'
import exportGraphKPIDataSlice from '../features/device-dashboard/redux/exportGraphKPIDataSlice'
import customDeviceListSlice from '../features/custom-device/redux/deviceListSlice'
import customDeviceDeleteReducer from '../features/custom-device/redux/deviceDeleteSlice'
import customDeviceInfoReducer from '../features/custom-device/redux/createDeviceInfoSlice'
import customDeviceDataExportReducer from '../features/custom-device/redux/exportCustomDeviceDataSlice'
import customDeviceDropDownMetaReducer from '../features/custom-device/redux/getDeviceDropDownMetaDataSlice'
import menuInfoReducer from '../features/dashboard/redux/menuInfoSlice'
import alarmMetaData from '../features/device-management/redux/alarmMetaDataSlice'
import frequencyMetaData from '../features/device-management/redux/frequencyMetaDataSlice'
import getDeviceByIdReducer from '../features/custom-device/redux/getDeviceDataByIdSlice'
import updateDeviceTemplateReducer from '../features/custom-device/redux/updateDeviceTemplateSlice'
import TimezoneDropDownReducer from '../features/gateway-management/redux/timezoneDataSlice'
import healthSummarySlice from '../features/device-dashboard/redux/getHealthSummarySlice'
import deviceStatusRegisterSummarySlice from '../features/device-dashboard/redux/getDeviceStatusSummaryRegisterSlice'
import deviceStatusKPISummarySlice from '../features/device-dashboard/redux/getDeviceStatusSummaryKPISlice'
import saveDefaultViewWidgetDetailsReducer from '../features/device-dashboard/redux/getSaveDefaultViewServiceSlice'
import SaveDefaultViewObjectReducer from '../features/device-dashboard/redux/saveDefaultViewObjectSlice'
import healthScoreReducer from '../features/asset-dashboard/redux/healthScoreSlice'
import assetAlarmReducer from '../features/asset-dashboard/redux/assetAlarmSlice'
import healthScoreAssetDashboardReducer from '../features/asset-dashboard/redux/getTotalHealthScoreSlice'
import assetHeaderRegisterSummaryReducer from '../features/asset-dashboard/redux/getAssetDashboardHeaderRegisterSummarySlice'
import assetHeaderKPISummaryReducer from '../features/asset-dashboard/redux/getAssetDashboardHeaderKPISummarySlice'
import addAssetKpiAlarmReducer from '../features/custom-performance-indicators/redux/addAssetKpiAlarmSlice'
import assetPerformanceDataReducer from '../features/asset-dashboard/redux/getAssetPerformanceDataSlice'
import assetPerformanceKPIDataReducer from '../features/asset-dashboard/redux/getAssetPerformanceKPIDataSlice'
import assetAlertCountDataReducer from '../features/asset-dashboard/redux/getAlertCountAssetDashbordSlice'
import alertTrendRegisterDataAssetDashboardReducer from '../features/asset-dashboard/redux/getAlertTrendRegisterDataSlice'
import alertTrendKPIDataAssetDashboardReducer from '../features/asset-dashboard/redux/getAlertTrendAssetKPIDataSlice'
import alertTrendRegisterDataDeviceDashboardReducer from '../features/device-dashboard/redux/getAlertTredRegisterDataSlice'
import alertTrendKPIDataDeviceDashboardReducer from '../features/device-dashboard/redux/getAlertTredKPIDataDeviceDashboardSlice'
import kpiAssetListReducer from '../features/custom-performance-indicators/redux/kpiAssetListSlice'
import parameterTreeReducer from '../features/asset-dashboard/redux/parameterTreeSlice'
import flameKPIAssetDataReducer from '../features/asset-dashboard/redux/getFlameKPIDataSlice'
import flameRegisterDateReducer from '../features/asset-dashboard/redux/getFlameRegisterDataSlice'
import flowKPIAssetDataReducer from '../features/asset-dashboard/redux/getFlowKPIDataSlice'
import flowRegisterDataReducer from '../features/asset-dashboard/redux/getFlowRegisterDataSlice'
import SaveBookmarkDetailsReducer from '../features/bookmarks-home/redux/toggleBookmarkSlice'
import GetBookmarkDetailsReducer from '../features/bookmarks-home/redux/getBookmarkSlice'
import SaveBookmarkObjectReducer from '../features/bookmarks-home/redux/saveBookmarkObjectSlice'
import emailGroupsListReducer from '../features/services/redux/emailGroupsListSlice'
import emailGroupDetailsReducer from '../features/services/redux/emailGroupDetailsSlice'
import getParameterConfigurationDataReducer from '../features/services/redux/parameterConfigurationsSlice'

const store = configureStore({
  reducer: {
    language: languageReducer,
    deviceInfo: deviceInfoReducer,
    kpiList: kpiListSlice,
    emailGroupsList: emailGroupsListReducer,
    emailGroupDetails: emailGroupDetailsReducer,
    deviceKpiList: deviceKpiListSlice,
    grandParentBreadcrumb: grandParentBreadcrumbReducer,
    operationPermissions: operationPermissionsReducer,
    hamburgerState: hamburgerStateReducer,
    // ThermalIQ Custom KPI
    customKpi: customKpiSlice,
    tiqAssetList: assetListSlice,
    deviceParameters: deviceParameterSlice,
    createCustomKpi: createCustomKpiSlice,
    kpiDetails: customKpiDetails,
    tiqSiteList: siteList,
    editCustomKpi: editCustomKpiSlice,
    kpiConfigurations: kpiConfigurationSlice,
    // device management
    deviceManagementDeviceList: deviceManagementDeviceListSlice,
    deviceDeleteState: deviceDeleteReducer,
    deviceManagementGatewayInfo: gatewayInfoSlice,
    assetCategories: assetCategoriesSlice,
    deviceType: deviceTypeSlice,
    deviceModel: deviceModelSlice,
    performanceIndicator: indicatorSlice,
    deviceInfoState: deviceInfoSlice,
    modbusParameters: modbusParamsSlice,
    updateDeviceState: updateDeviceReducer,
    downloadImageState: downloadImageReducer,
    deviceIndicatorState: addDeviceIndicatorReducer,
    deviceParameterState: addDeviceParameterReducer,
    defaultParameterState: addDefaultParameterReducer,
    imageUploadState: imageUploadReducer,
    createDeviceState: createDeviceReducer,
    defaultIndicatorState: addDefaultIndicatorReducer,
    alarmMetaDataState: alarmMetaData,
    frequencyMetaDataState: frequencyMetaData,
    // gateway management
    gatewayManagementGatewayList: gatewayManagementGatewayListSlice,
    // asset management
    assetManagementAssetList: assetManagementAssetListSlice,
    assetManagementSiteInfo: siteInfoSlice,
    gatewayDeleteState: gatewayDeleteReducer,
    assetDeleteState: assetDeleteReducer,
    gatewayManagementAssetInfo: assetInfoSlice,
    updateAssetState: updateAssetSlice,
    gatewayManagementAssetCategories: assetCategoriesSliceGateway,
    gatewayManagementGatewayType: gatewayTypeSlice,
    createGatewayState: createGatewayReducer,
    imageUploadStateGateway: imageUploadReducerGateway,
    createAssetState: createAssetReducer,
    imageUploadStateAsset: imageUploadReducerAsset,
    gatewayInfoState: gatewayInfoSliceGateway,
    updateGatewayState: updateGatewayReducer,
    downloadImageStateGateway: downloadImageReducerGateway,
    // device Dashbaord
    flameSignalReadingData: FlameSignaGraphDataSliceReducer,
    flameSignalData_NEW: FlameSignaGraphDataSliceReducer_NEW,
    flameSignaGraphKPIData: getFlameSignaGraphKPIDataSlice,
    flowSignalParamData: flowSignalParamDataSlice,
    flowSignalKpiData: flowSignalKpiDataSlice,
    flowSignalReadingData: FlowSignaGraphDataSliceReducer,
    ModBusParameterListData: modbusParamsSliceReducer,
    DeviceListData: DeviceListReducer,
    StandardandCustomListData: StandardandCustomListDataReducer,
    DeviceStatusListData: DeviceStatusReducer,
    AlertsCountDetailsData: AlertCountDetailsReducer,
    SaveDefaultViewData: SaveDefaultViewDetailsReducer,
    SaveBookmarkData: SaveBookmarkDetailsReducer,
    GetBookmarkData: GetBookmarkDetailsReducer,
    AlertsNotificationData: AlertsNotificationReducer,
    ClearNotificationData: ClearNotificationReducer,
    AcknowledgeNotificationData: acknowledgeNotificationNotificationReducer,
    DeviceStatusOnlineData: DeviceOnlineStatusReducer,
    ExportGraphDataState: exportDeviceGrapData,
    ExportGraphKPIDataState: exportGraphKPIDataSlice,
    HealthSummaryState: healthSummarySlice,
    deviceStatusRegisterSummaryState: deviceStatusRegisterSummarySlice,
    deviceStatusKPISummaryState: deviceStatusKPISummarySlice,
    // site management
    siteManagementSiteList: siteManagementSiteListSlice,
    siteDeleteState: siteDeleteReducer,
    createSiteState: createSiteReducer,
    imageUploadStateSite: imageUploadReducerSite,
    siteInfoState: siteInfoReducer,
    downloadImageSiteState: downloadImageReducerSite,
    updateSiteState: updateSiteReducer,
    // custom device template
    customDeviceList: customDeviceListSlice,
    customDeviceDeleteState: customDeviceDeleteReducer,
    createCustomDeviceInfoState: customDeviceInfoReducer,
    exportCustomDeviceData: customDeviceDataExportReducer,
    deviceDropDownMetadata: customDeviceDropDownMetaReducer,
    UpdateCustomDevice: updateDeviceTemplateReducer,
    customDeviceListByID: getDeviceByIdReducer,
    menuInfoState: menuInfoReducer,
    saveDefaultWidgetData: saveDefaultViewWidgetDetailsReducer,
    saveDefaultViewObject: SaveDefaultViewObjectReducer,
    saveBookmarkObject: SaveBookmarkObjectReducer,
    timezoneDropDownMetaData: TimezoneDropDownReducer,
    assetHealthScore: healthScoreReducer,
    assetAlarmState: assetAlarmReducer,
    HealthScoreAssetDashboard: healthScoreAssetDashboardReducer,
    headerSummaryRegisterAssetData: assetHeaderRegisterSummaryReducer,
    headerSummaryKPIAssetData: assetHeaderKPISummaryReducer,
    assetKpiAlarmData: addAssetKpiAlarmReducer,
    assetPerformanceData: assetPerformanceDataReducer,
    AssetPerformanceKPIData: assetPerformanceKPIDataReducer,
    AlertCountDataAssetDashboard: assetAlertCountDataReducer,
    alertTrendRegisterAssetDashboard: alertTrendRegisterDataAssetDashboardReducer,
    alertTrendKPIAssetDashboard: alertTrendKPIDataAssetDashboardReducer,
    alertTrendRegisterDeviceDashboard: alertTrendRegisterDataDeviceDashboardReducer,
    alertTrendKPIDeviceDashboard: alertTrendKPIDataDeviceDashboardReducer,
    kpiAssetList: kpiAssetListReducer,
    parameterTree: parameterTreeReducer,
    FlameSignaGraphDataAssetDashboard: FlameSignaGraphDataAssetDashboardSliceReducer,
    FlowSignaGraphDataAssetDashboard: FlowSignaGraphDataAssetDashboardSliceReducer,
    flameKPIAssetData: flameKPIAssetDataReducer,
    flameRegisterData: flameRegisterDateReducer,
    flowKPIAssetData: flowKPIAssetDataReducer,
    flowRegisterData: flowRegisterDataReducer,
    getParameterConfigurationData: getParameterConfigurationDataReducer
  },
  middleware: [thunk, logger]
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
